import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  RiFolder2Line,
  RiCheckLine,
  RiCloseLine,
  RiIndeterminateCircleLine,
  RiFolderForbidLine,
} from 'react-icons/ri';
import { BsFileDiff } from 'react-icons/bs';
import lodashSortBy from 'lodash/sortBy';
import ProgressRing from '@hig/progress-ring';
import Button from '@hig/button';
import TextLink from '@hig/text-link';
import Flyout, { anchorPoints } from '@hig/flyout';
import SchemaViewer from '../../components/SchemaValidationViewer/SchemaValidationViewer';
import { default as MatrixTable, Column, SortOrder } from '@adsk/bim360-matrix-react-matrix-table';
import { Breadcrumbs } from '@adsk/model-browser-react-components';
import { GitHubAPIHelper } from '../../data/api/github';
// import request from 'request-promise';
import {
  FORGESCHEMA_BASE_URL,
  makeAuthFetch,
  ForgeEnvironmentEnum,
  PermissionEnum,
  PublishStatusEnum,
  setNamespacePermission,
  getPathPermission,
} from '../../data/api/utils';
import {
  URL_LOCALIZATION_GITHUB_URL,
  NAME_FORGE_SCHEMA_LOCALIZATION_REPOSITORY,
  NAME_FORGE_SCHEMA_LOCALIZATION_OWNER,
} from '../../service/constants';
import ForgeSchemaAPIHelper from '../../data/api/forgeschema';
import settings from '../../settings/allowNamespaces';
import { diff } from 'deep-diff';

const columnDefinition = {
  name: {
    key: 'name',
    title: 'Name',
  },
  origin: {
    key: 'origin',
    title: 'Origin',
  },
  role: {
    key: 'role',
    title: 'Role',
  },
  fssStaging: {
    key: 'stagingstatus',
    title: 'FSS Staging',
  },
  fssProduction: {
    key: 'productionstatus',
    title: 'FSS Production',
  },
};

// path = "parameter/group/en-us"
// returns = "autodesk.parameter.group"
const mapLocalReposiotryPathToFSSNamespace = (path) => {
  const strings = path.split('/').filter((v) => v.indexOf('-') < 0); // remove the locale folder.
  if (path.indexOf('.json') >= 0) {
    strings.pop(); // remove json file name.
  }
  return 'autodesk.' + strings.join('.');
};

const setSchemaStatus = (path, isStaging, status) => {
  const fssStatusLatest = JSON.parse(localStorage.FSSStatus);
  if (fssStatusLatest[path] === undefined) {
    fssStatusLatest[path] = {
      staging: PublishStatusEnum.UNKNOWN,
      production: PublishStatusEnum.UNKNOWN,
    };
  }
  if (isStaging) {
    fssStatusLatest[path].staging = status;
  } else {
    fssStatusLatest[path].production = status;
  }
  localStorage.FSSStatus = JSON.stringify(fssStatusLatest);
};

export class ForgeSchemasLocalizationBroswer extends Component {
  state = {
    isLoading: true,
    items: [],
    folderNavChain: [
      {
        name: 'ForgeSchemasLocalization',
        path: '/',
        id: '/',
        type: 'dir',
        stagingstatus: PublishStatusEnum.UNKNOWN,
        productionstatus: PublishStatusEnum.UNKNOWN,
        permission: PermissionEnum.UNKNOWN,
      },
    ],
    sort: {
      key: columnDefinition.name.key,
      order: SortOrder.ASC,
    },
    selection: {},
    showSchemaViewer: false,
    sourceJson: {},
    targetJson: {},
    jsonDifference: undefined,
    fssReport: undefined,
    error: {},
  };

  onHandleItemClick = (data) => {
    // console.log(data);
    if (data.type === 'dir') {
      this.getItems(data.path)
        .then((items) => {
          const { folderNavChain } = this.state;
          folderNavChain.push(data);
          this.setState({ items, folderNavChain, selection: {} });
        })
        .catch((err) => {
          this.setState({ ...this.state, error: err });
        });
    } else if (data.type === 'file') {
      this.getItemJson(data.path)
        .then((file) => {
          const schemaString = Buffer.from(file.content, 'base64').toString('utf8');
          const gitSchema = JSON.parse(schemaString);
          this.setState({
            sourceJson: gitSchema,
          });
          const origin = gitSchema.origin;
          const locale = gitSchema.locale;
          const path = data.path;
          const forgeHelper = new ForgeSchemaAPIHelper(
            FORGESCHEMA_BASE_URL,
            this.props.token,
            makeAuthFetch
          );
          forgeHelper
            .getAttachment(origin, `localization.${locale}`)
            .then((schema) => {
              // console.log(schema);
              const fssSchema = schema;
              const changes = diff.diff(
                gitSchema.constants,
                fssSchema.attributes.userData.constants
              );

              const itemIndex = this.state.items.findIndex((v) => v.path === path);
              const item = { ...this.state.items[itemIndex] };
              item.origin = origin;
              item.stagingstatus = changes
                ? PublishStatusEnum.SCHEMA_DIFFERENT
                : PublishStatusEnum.PUBLISHED;
              const items = [
                ...this.state.items.slice(0, itemIndex),
                item,
                ...this.state.items.slice(itemIndex + 1),
              ];
              setSchemaStatus(path, true, item.stagingstatus);
              this.setState({
                items,
                targetJson: schema,
                jsonDifference: changes,
                showSchemaViewer: true,
              });
            })
            .catch((err) => {
              // console.log(err);
              const itemIndex = this.state.items.findIndex((v) => v.path === path);
              const item = { ...this.state.items[itemIndex] };
              item.origin = origin;
              item.stagingstatus = PublishStatusEnum.NOT_PUBLISHED;
              const items = [
                ...this.state.items.slice(0, itemIndex),
                item,
                ...this.state.items.slice(itemIndex + 1),
              ];
              setSchemaStatus(path, true, item.stagingstatus);
              this.setState({
                items,
                targetJson: null,
                jsonDifference: gitSchema,
                showSchemaViewer: true,
                error: err,
              });
            });
        })
        .catch((err) => {
          this.setState({ ...this.state, error: err });
        });
    }
  };

  onHandleBreadcrumbClick = (item) => {
    this.getItems(item.path)
      .then((items) => {
        const { folderNavChain } = this.state;
        const index = folderNavChain.findIndex((curItem) => curItem.path === item.path);
        if (index === -1) {
          return;
        }
        const newFolderNavChain = folderNavChain.slice(0, index + 1);
        this.setState({ items, folderNavChain: newFolderNavChain, selection: {} });
      })
      .catch((err) => {
        this.setState({ ...this.state, error: err });
      });
  };

  _handleSelectAll = (selected) => {
    const selection = {};
    if (selected) {
      const allSelectedItems = this.state.items.filter((item) => item.type === 'file');
      allSelectedItems.forEach((i) => {
        selection[i.path] = i;
      });
    }
    this.setState({
      selection,
    });
  };

  onItemSelected = (selected, rowData) => {
    const selection = { ...this.state.selection };
    // console.log(selected);
    // console.log(rowData);
    if (selection[rowData.path] === undefined && selected) {
      selection[rowData.path] = rowData;
    } else if (selection[rowData.path] !== undefined && !selected) {
      delete selection[rowData.path];
    } else {
      throw new Error(`${rowData.path}'s selection status is ${selected}`);
    }
    this.setState({
      selection,
    });
  };

  _handleExitSchemaViewer = () => {
    this.setState({
      showSchemaViewer: false,
      targetJson: {},
      sourceJson: {},
    });
  };

  _handleGetFSSStatusReport = () => {
    if (localStorage.FSSStatus === undefined) {
      return;
    }
    const fssStatus = JSON.parse(localStorage.FSSStatus);
    const pathes = Object.keys(fssStatus);
    const result = [];
    pathes.forEach((p) => {
      const ns = p.substring(p.indexOf('/') + 1, p.lastIndexOf('/')).replace(/\//g, '.');
      if (
        this.isNamespaceInAllowList(ns) &&
        (fssStatus[p].staging === PublishStatusEnum.NOT_PUBLISHED ||
          fssStatus[p].staging === PublishStatusEnum.SCHEMA_DIFFERENT)
      ) {
        result.push({
          path: p,
          staging: fssStatus[p].staging,
        });
      }
    });

    this.setState({
      fssReport: result,
    });
  };

  _handleCheckFSSStatus = () => {
    // console.log(this.state.selection);
    const pathes = Object.keys(this.state.selection);

    // update the status to "updating".
    const arrIndex = [];
    pathes.forEach((path) => {
      const itemIndex = this.state.items.findIndex((v) => v.path === path);
      if (itemIndex >= 0) {
        arrIndex.push(itemIndex);
      }
    });

    let items = [...this.state.items];
    arrIndex.forEach((i) => {
      const item = { ...items[i] };
      item.stagingstatus = PublishStatusEnum.UPDATING;
      items = [...items.slice(0, i), item, ...items.slice(i + 1)];
    });
    this.setState({
      items,
    });

    pathes.forEach((path) => {
      if (localStorage.FSSStatus === undefined) {
        localStorage.setItem('FSSStatus', '{}');
      }

      this.getItemJson(path)
        .then((file) => {
          const schemaString = Buffer.from(file.content, 'base64').toString('utf8');
          const gitSchema = JSON.parse(schemaString);
          const origin = gitSchema.origin;
          const locale = gitSchema.locale;
          const forgeHelper = new ForgeSchemaAPIHelper(
            FORGESCHEMA_BASE_URL,
            this.props.token,
            makeAuthFetch
          );
          forgeHelper
            .getAttachment(origin, `localization.${locale}`)
            .then((schema) => {
              // console.log(schema);
              const fssSchema = schema;
              const changes = diff.diff(
                gitSchema.constants,
                fssSchema.attributes.userData.constants
              );
              const itemIndex = this.state.items.findIndex((v) => v.path === path);
              const item = { ...this.state.items[itemIndex] };
              item.stagingstatus = changes
                ? PublishStatusEnum.SCHEMA_DIFFERENT
                : PublishStatusEnum.PUBLISHED;
              const items = [
                ...this.state.items.slice(0, itemIndex),
                item,
                ...this.state.items.slice(itemIndex + 1),
              ];
              setSchemaStatus(path, true, item.stagingstatus);
              this.setState({
                items,
              });
            })
            .catch((err) => {
              // console.log(err);
              const itemIndex = this.state.items.findIndex((v) => v.path === path);
              const item = { ...this.state.items[itemIndex] };
              item.stagingstatus = PublishStatusEnum.NOT_PUBLISHED;
              const items = [
                ...this.state.items.slice(0, itemIndex),
                item,
                ...this.state.items.slice(itemIndex + 1),
              ];
              setSchemaStatus(path, true, item.stagingstatus);
              this.setState({
                items,
                error: err,
              });
            });
        })
        .catch((err) => {
          this.setState({ ...this.state, error: err });
        });
    });
  };

  isNamespaceInAllowList = (ns) => {
    if (ns === undefined || typeof ns !== 'string') {
      return false;
    } else {
      return settings.allow.find((n) => ns.indexOf(n) > -1) !== undefined;
    }
  };

  renderOriginCell = ({ rowData }) => {
    return rowData.origin ? rowData.origin : 'unknown';
  };

  renderNameCell = ({ rowData }) => {
    const isFolder = rowData.type === 'dir';
    const path = rowData.path;
    let ns = 'autodesk';
    if (isFolder) {
      ns = path.substring(path.indexOf('/') + 1).replace(/\//g, '.');
    } else {
      ns = path.substring(path.indexOf('/') + 1, path.lastIndexOf('/')).replace(/\//g, '.');
    }
    const isAllToUpload = this.isNamespaceInAllowList(ns);
    return (
      <div className="itemcell" key={rowData.path}>
        {isFolder &&
          (isAllToUpload ? (
            <RiFolder2Line className="itemicon" />
          ) : (
            <RiFolderForbidLine className="itemicon" />
          ))}
        <TextLink
          onClick={() => {
            this.onHandleItemClick(rowData);
          }}
        >
          {rowData.name}
        </TextLink>
      </div>
    );
  };

  renderRoleCell = (cellData) => {
    if (cellData.rowData.permission === PermissionEnum.UNKNOWN) {
      return (
        <div key={cellData.column.dataKey + cellData.rowData.path}>
          <ProgressRing size="xs" />
        </div>
      );
    }
    switch (cellData.rowData.permission) {
      case PermissionEnum.UNKNOWN:
        return (
          <div key={cellData.column.dataKey + cellData.rowData.path}>
            <ProgressRing size="xs" />
          </div>
        );
      case PermissionEnum.NAMESPACE_ADMIN:
        return <p>Admin</p>;
      case PermissionEnum.SCHEMA_AUTHOR:
        return <p>Schema author</p>;
      case PermissionEnum.SCHEMA_READER:
        return <p>Schema reader</p>;
      case PermissionEnum.NOT_EXIST:
        return <p>This namespace is not exist!</p>;
      default:
        return <p>Unknown</p>;
    }
  };

  renderStatusCell = (cellData) => {
    if (cellData.column.dataKey === 'productionstatus') {
      if (cellData.rowData.productionstatus === PublishStatusEnum.UNKNOWN) {
        return (
          <div key={cellData.column.dataKey + cellData.rowData.path}>
            <RiIndeterminateCircleLine />
          </div>
        );
      }
    }
    if (cellData.column.dataKey === 'stagingstatus') {
      if (cellData.rowData.stagingstatus === PublishStatusEnum.UNKNOWN) {
        return (
          <div key={cellData.column.dataKey + cellData.rowData.path}>
            <RiIndeterminateCircleLine />
          </div>
        );
      } else if (cellData.rowData.stagingstatus === PublishStatusEnum.PUBLISHED) {
        return (
          <div key={cellData.column.dataKey + cellData.rowData.path}>
            <RiCheckLine className="info" />
          </div>
        );
      } else if (cellData.rowData.stagingstatus === PublishStatusEnum.NOT_PUBLISHED) {
        return (
          <div key={cellData.column.dataKey + cellData.rowData.path}>
            <RiCloseLine className="error" />
          </div>
        );
      } else if (cellData.rowData.stagingstatus === PublishStatusEnum.SCHEMA_DIFFERENT) {
        return (
          <div key={cellData.column.dataKey + cellData.rowData.path}>
            <BsFileDiff className="error" />
          </div>
        );
      } else if (cellData.rowData.stagingstatus === PublishStatusEnum.UPDATING) {
        return (
          <div key={cellData.column.dataKey + cellData.rowData.path}>
            <ProgressRing size="xs" />
          </div>
        );
      } else {
        return (
          <div key={cellData.column.dataKey + cellData.rowData.path}>
            <ProgressRing size="xs" />
          </div>
        );
      }
    }
    return (
      <div key={cellData.column.dataKey + cellData.rowData.path}>
        <ProgressRing size="xs" />
      </div>
    );
  };

  renderBreadcrumb = () => {
    const { folderNavChain } = this.state;
    return (
      <Breadcrumbs
        items={folderNavChain}
        onClick={(item) => this.onHandleBreadcrumbClick(item)}
        icon={<RiFolder2Line className="itemicon" />}
        hidden={!(folderNavChain && folderNavChain.length > 1)}
      />
    );
  };

  _handleClickOutside = () => {};

  _handleScroll = () => {};

  renderToolbar = () => {
    return (
      <div>
        <Flyout
          className="report"
          content={({ hideFlyout }) => {
            const { fssReport } = this.state;
            const fssReportContent =
              fssReport === undefined ? (
                <p>No report! Please check the status first.</p>
              ) : (
                <ul>
                  {fssReport.map((item) => {
                    let icon = <BsFileDiff className="error" />;
                    if (item.staging === PublishStatusEnum.NOT_PUBLISHED) {
                      icon = <RiCloseLine className="error" />;
                    }
                    return (
                      <li key={item.path}>
                        {icon}
                        {item.path}
                      </li>
                    );
                  })}
                </ul>
              );
            return (
              <div>
                {fssReportContent}
                <button type="button" onClick={hideFlyout}>
                  Click to hide
                </button>
              </div>
            );
          }}
          anchorPoint={anchorPoints.TOP_LEFT}
          onClickOutside={this._handleClickOutside}
          onScroll={this._handleScroll}
        >
          <Button title="Report" onClick={this._handleGetFSSStatusReport} />
        </Flyout>
        <Button
          size="standard"
          title="Check FSS Status"
          type="primary"
          onClick={this._handleCheckFSSStatus}
        />
      </div>
    );
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.getItems('/')
      .then((items) => {
        this.setState({
          items,
          isLoading: false,
        });
      })
      .catch((err) => {
        this.setState({ ...this.state, error: err });
      });
  }

  getItemJson = (path) => {
    const gitHubAPIHelper = new GitHubAPIHelper(
      URL_LOCALIZATION_GITHUB_URL,
      NAME_FORGE_SCHEMA_LOCALIZATION_REPOSITORY,
      NAME_FORGE_SCHEMA_LOCALIZATION_OWNER
    );
    return gitHubAPIHelper
      .getContent(path)
      .then((res) => {
        // console.log(content);
        if (res.data.name.includes('.json')) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((err) => {
        this.setState({ ...this.state, error: err });
      });
  };

  getItems = (path) => {
    const gitHubAPIHelper = new GitHubAPIHelper(
      URL_LOCALIZATION_GITHUB_URL,
      NAME_FORGE_SCHEMA_LOCALIZATION_REPOSITORY,
      NAME_FORGE_SCHEMA_LOCALIZATION_OWNER
    );
    return gitHubAPIHelper
      .getContent(path)
      .then((result) => {
        const content = result ? result.data : [];
        // console.log(content);
        const items = content
          .filter((i) => i.type === 'dir' || i.path.substring(i.path.lastIndexOf('.')) === '.json')
          .map((i) => {
            // checks the status from localstorage.
            if (localStorage.FSSStatus === undefined) {
              localStorage.setItem('FSSStatus', '{}');
            }
            let stagingstatus = PermissionEnum.UNKNOWN;
            let productionstatus = PermissionEnum.UNKNOWN;
            const fssStatus = JSON.parse(localStorage.FSSStatus);
            if (fssStatus[i.path] !== undefined) {
              const status = fssStatus[i.path];
              stagingstatus = status.staging ? status.staging : stagingstatus;
              productionstatus = status.production ? status.production : productionstatus;
            }
            return {
              name: i.name,
              path: i.path,
              id: i.path,
              type: i.type,
              permission: PermissionEnum.UNKNOWN,
              stagingstatus,
              productionstatus,
            };
          });
        return items;
      })
      .then((items) => {
        // checks the role of this namespace.
        const promises = [];
        items.forEach((i) => {
          // checks the role of this namespace.
          if (i.type === 'dir') {
            const folderPermission = getPathPermission(ForgeEnvironmentEnum.STAGING, i.path);
            if (folderPermission === PermissionEnum.NAMESPACE_ADMIN) {
              i.permission = folderPermission;
              promises.push(i);
              return;
            }

            const namespaceId = mapLocalReposiotryPathToFSSNamespace(i.path);
            // console.log(namespaceId);
            const forgeHelper = new ForgeSchemaAPIHelper(
              FORGESCHEMA_BASE_URL,
              this.props.token,
              makeAuthFetch
            );
            promises.push(
              forgeHelper
                .getNamespace(namespaceId)
                .then((ns) => {
                  let permission = PermissionEnum.UNKNOWN;
                  const permissions = ns.data.attributes.permissions;
                  if (
                    permissions !== undefined &&
                    Array.isArray(permissions) &&
                    permissions.length > 0
                  ) {
                    for (let i = 0; i < permissions.length; i++) {
                      const p = permissions[i];
                      if (
                        p.role === 'NAMESPACE_ADMIN' &&
                        p.subjects.o2Users.indexOf(this.props.userId) >= 0
                      ) {
                        permission = PermissionEnum.NAMESPACE_ADMIN;
                        break;
                      } else if (
                        p.role === 'SCHEMA_AUTHOR' &&
                        p.subjects.o2Users.indexOf(this.props.userId) >= 0
                      ) {
                        permission = PermissionEnum.SCHEMA_AUTHOR;
                        break;
                      } else if (
                        p.role === 'SCHEMA_READER' &&
                        p.subjects.o2Users.indexOf(this.props.userId) >= 0
                      ) {
                        permission = PermissionEnum.SCHEMA_READER;
                        break;
                      }
                    }
                  }
                  if (permission === PermissionEnum.UNKNOWN) {
                    permission = PermissionEnum.SCHEMA_READER;
                  }
                  i.permission = permission;
                  setNamespacePermission(ForgeEnvironmentEnum.STAGING, i.path, permission);
                  return i;
                })
                .catch((err) => {
                  // console.log(err);
                  this.setState({ ...this.state, error: err });
                  // no any permission to this namespace, let's set it to reader.
                  i.permission = PermissionEnum.NOT_EXIST;
                  setNamespacePermission(ForgeEnvironmentEnum.STAGING, i.path, i.permission);
                  return i;
                })
            );
          } else {
            i.permission = getPathPermission(
              ForgeEnvironmentEnum.STAGING,
              mapLocalReposiotryPathToFSSNamespace(i.path)
            );
            promises.push(i);
          }
        });
        return Promise.all(promises);
      })
      .catch((err) => {
        this.setState({ ...this.state, error: err });
      });
  };
  sortKeyGenerator = (rowdata, sort) => {
    const sortKey = rowdata[sort.key];
    if (!sortKey) {
      return '';
    }
    return sortKey.toString().toLowerCase();
  };

  _handleSort = (data, sort) => {
    if (!data) {
      return [];
    }
    let folders = data.filter((rowData) => rowData.type === 'dir');
    if (sort.key === 'name') {
      folders = lodashSortBy(folders, (x) => this.sortKeyGenerator(x, sort));
      if (sort.order === SortOrder.DESC) {
        folders.reverse();
      }
    }

    let items = data.filter((rowData) => rowData.type === 'file');
    items = lodashSortBy(items, (x) => this.sortKeyGenerator(x, sort));
    if (sort.order === SortOrder.DESC) {
      items.reverse();
    }

    return folders.concat(items);
  };

  _handleColumnSort = (sort) => {
    this.setState({ sort });
  };

  render() {
    const { items, isLoading, showSchemaViewer, sourceJson, targetJson, jsonDifference } =
      this.state;
    return (
      <>
        <div className="browser">
          <h2>Welcome to Raw Schema Localization (GitHub) Browser</h2>
          <div className="toolbar">{this.renderToolbar()}</div>
          <div className="breadcrumb">{this.renderBreadcrumb()}</div>
          <div className="table">
            <MatrixTable
              selectable={true}
              sortBy={this.state.sort}
              onSelectAll={this._handleSelectAll}
              onColumnSort={this._handleColumnSort}
              onRowSelect={({ selected, rowData }) => this.onItemSelected(selected, rowData)}
              rowKey={'name'}
              data={this._handleSort(items, this.state.sort)}
              loading={isLoading}
            >
              <Column
                title={columnDefinition.name.title}
                key={columnDefinition.name.key}
                dataKey={columnDefinition.name.key}
                disableTooltip={true}
                width={200}
                minWidth={100}
                sortable
                resizable
                cellRenderer={this.renderNameCell}
              />
              <Column
                title={columnDefinition.origin.title}
                key={columnDefinition.origin.key}
                dataKey={columnDefinition.origin.key}
                disableTooltip={true}
                width={500}
                minWidth={100}
                sortable
                resizable
                cellRenderer={this.renderOriginCell}
              />
              <Column
                title={columnDefinition.role.title}
                key={columnDefinition.role.key}
                dataKey={columnDefinition.role.key}
                disableTooltip={true}
                width={200}
                minWidth={100}
                sortable
                resizable
                cellRenderer={this.renderRoleCell}
              />
              <Column
                title={columnDefinition.fssStaging.title}
                key={columnDefinition.fssStaging.key}
                dataKey={columnDefinition.fssStaging.key}
                disableTooltip={true}
                width={150}
                minWidth={100}
                sortable
                resizable
                cellRenderer={this.renderStatusCell}
              />
              <Column
                title={columnDefinition.fssProduction.title}
                key={columnDefinition.fssProduction.key}
                dataKey={columnDefinition.fssProduction.key}
                disableTooltip={true}
                width={150}
                minWidth={100}
                sortable
                resizable
                cellRenderer={this.renderStatusCell}
              />
            </MatrixTable>
          </div>
        </div>
        {showSchemaViewer && (
          <SchemaViewer
            open={showSchemaViewer}
            jsonDifference={jsonDifference}
            sourceJson={sourceJson}
            targetJson={targetJson}
            onExited={this._handleExitSchemaViewer}
          />
        )}
      </>
    );
  }
}

ForgeSchemasLocalizationBroswer.propTypes = {
  token: PropTypes.string,
  userId: PropTypes.string,
};

export default ForgeSchemasLocalizationBroswer;
